import React from "react";

// One memorandum section: a generated draft (grey "Generated") the analyst can
// edit inline; once edited/stored it reads as "Analyst verified".
export default function MemoCard({ title, value, generated, onChange, disabled }) {
  const isGenerated = !value;
  return (
    <div className="rounded-card border border-card-bd bg-card p-5">
      <div className="mb-1.5 flex items-center justify-between">
        <div className="text-[13px] font-semibold text-text-2">{title}</div>
        <span className={`text-[11px] font-medium uppercase tracking-wide ${isGenerated ? "text-text-3" : "text-success"}`}>{isGenerated ? "Generated" : "Analyst verified"}</span>
      </div>
      <textarea
        style={{ width: "100%" }}
        className="block box-border rounded-[10px] border border-card-bd bg-card p-3 text-[14px] leading-relaxed text-text-2 disabled:opacity-60"
        rows={3}
        value={value || ""}
        placeholder={generated}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-label={title}
      />
    </div>
  );
}
